module.exports = __webpack_public_path__ + "494cd07c/img/verified-icon.f93bbc14.svg";